const environments = {
  PRODUCTION: 'production',
  STAGING: 'staging',
  DEVELOPMENT: 'development'
};

class BigBrainClient {
  constructor(env, appName, logger, fetchClient, uuidGen) {
    this.env = env;
    this.source = appName;
    this.logger = logger;
    this.fetchClient = fetchClient;
    this.uuidGen = uuidGen;

    if (this.env === environments.PRODUCTION) {
      this.bigBrainDomain = 'https://track.bigbrain.me/prod';
    } else if (this.env === environments.STAGING) {
      this.bigBrainDomain = 'https://track.bigbrainstaging.me/stage';
    } else {
      this.bigBrainDomain = 'http://localhost:3002';
      this.source = 'test';
    }

    if (!this.source) {
      throw new Error('No appName given');
    }
  }

  async track(eventName, eventData = {}) {
    if (this.env !== environments.PRODUCTION && this.env !== environments.STAGING) {
      this.logger.info(
        eventData,
        `BigBrain event: ${eventName}`,
      );

      return;
    }

    const event = {
      name: eventName,
      source: this.source,
      uuid: this.uuidGen.v4(),
      ...eventData,
    };

    try {
      await this.fetchClient(
        `${this.bigBrainDomain}/event`,
        {
          method: 'POST',
          body: JSON.stringify(event),
          headers: {
            'User-Agent': 'monday',
            'Content-Type': 'application/json'
          }
        }
      );
    } catch (error) {
      this.logger.error(
        {
          error: {
            message: error.message,
            stack: error.stack
          },
          event
        },
        'While trying to send BigBrain track event, caught error'
      );
    }
  }
}

module.exports = BigBrainClient;
